// extracted by mini-css-extract-plugin
export default {"modal":"add-public-category-modal_modal__5569W","modal__title":"add-public-category-modal_modal__title__J-0xN","modal__form":"add-public-category-modal_modal__form__V38uI"};